import defaultColor from "@/components/color";

const dataJson = [
    {name:'工序1',width:30,height:22},
    {name:'工序2',width:40,height:12},
    {name:'工序3',width:50,height:15},
    {name:'工序4',width:20,height:14},
    {name:'工序5',width:60,height:20},
    {name:'工序6',width:20,height:20},
    {name:'工序7',width:50,height:5},
    {name:'工序8',width:60,height:10},
    {name:'工序9',width:50,height:10},
    {name:'工序10',width:20,height:20},
    {name:'工序11',width:50,height:15},
    {name:'工序12',width:20,height:25}
]

export default {
    cptDataForm: {
        dataSource: 1, pollTime: 0, dataText: JSON.stringify(dataJson),
    },
    attribute: {
        colors:defaultColor,
        columnNum:3,
        title: {
            text: '工序人员安排一览',
            //subtext: '纯属虚构',
            left: 'center',
            top: 0,
            textStyle:{
                fontSize:18,
                color: '#ccc'
            },
            subtextStyle: { fontSize: 12, color: '#aaa' }
        },
        xAxis: {
            show: true,
            name: '',
            axisLabel:{
                show: true,
                color: '#6aa9e4',
                fontSize:13,
                rotate:0,//倾斜角度-180~180
                interval: ''
            },
            axisLine:{
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick:{//x轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: false
            }
        },
        yAxis: {
            show: true,
            name: '',
            type: 'value',
            axisLabel:{
                show: true,
                color: '#6aa9e4',
                fontSize: 13,
                formatter:'{value}'
            },
            axisLine:{
                show: false,
                lineStyle:{
                    color: '#eee'
                }
            },
            axisTick:{//y轴刻度线
                show: false
            },
            splitLine: {//网格线
                show: true,
                lineStyle:{
                    color: ['#14477e', '#14477e']
                }
            }
        },
        label:{
            width: '耗时(小时)',
            height: '人数(人)'
        },
        legend: {
            show: true,
            // left: 'center',
            // top: 'bottom',
            // orient: 'horizontal',
            textStyle: {
                color: '#6aa9e4',
                fontSize: 14
            }
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        dataZoom: {show: false,height:15},
        cptTableData: [{ "name": "名称", "value": "", "namekey": "name" },
        { "name": "宽度", "value": "", "namekey": "width" },
        { "name": "高度", "value": "", "namekey": "height" }]
    },
}
